import {
  TransactionItemDrawerMode,
  TransactionItemDrawerModeEnum,
  TransactionItemsColumn,
} from '@/features/transaction_items/List/type';
import { UnsupportedPlanWarning } from '@/features/transaction_items/components/UnsupportedPlanWarning/UnsupportedPlanWarning';
import { useTranslation } from '@/i18n';
import { useGlobalContainerRef } from '@/wc/helper/ref';
import {
  ButtonGroup,
  ButtonV2,
  Tooltip,
} from '@moneyforward/ap-frontend-components';
import classNames from 'classnames';
import { FC, memo } from 'react';
import styles from './Header.module.scss';

export type Props = {
  mode: TransactionItemDrawerMode;
  type?: TransactionItemsColumn['type'];
  onSetMode: (mode: TransactionItemDrawerMode) => void;
  isLoading: boolean;
  onDeleteClick: () => void;
  canDelete?: boolean;
  deleteTooltip?: string;
  isSupportedOffice?: boolean;
};

const cx = classNames.bind(styles);

export const TransactionItemHeader: FC<Props> = memo(
  ({
    mode,
    type,
    onSetMode,
    isLoading,
    onDeleteClick,
    canDelete,
    deleteTooltip,
    isSupportedOffice,
  }) => {
    const { t } = useTranslation();
    const globalContainer = useGlobalContainerRef();
    const isDeleteDisabled = canDelete === false || isLoading;
    const isBasicItem = type === 'basic';

    const deleteButton = (
      <ButtonV2
        isSecondary
        color='danger'
        isDisabled={isDeleteDisabled}
        onClick={onDeleteClick}
      >
        {t('delete')}
      </ButtonV2>
    );

    return (
      <div className={cx(styles['title'])}>
        {t(`transaction_items.drawer.${mode}.title`)}
        {!isSupportedOffice && !isBasicItem && <UnsupportedPlanWarning />}
        {mode === TransactionItemDrawerModeEnum.DETAIL && !isBasicItem && (
          <ButtonGroup direction='horizontal'>
            <Tooltip
              title={
                canDelete === false && deleteTooltip ? deleteTooltip : undefined
              }
              placement='bottom'
              getPopupContainer={globalContainer}
            >
              <span>{deleteButton}</span>
            </Tooltip>
            {isSupportedOffice && (
              <ButtonV2
                onClick={() => onSetMode(TransactionItemDrawerModeEnum.EDIT)}
                isSecondary
                isDisabled={isLoading}
              >
                {t('edit')}
              </ButtonV2>
            )}
          </ButtonGroup>
        )}
        {mode === TransactionItemDrawerModeEnum.DETAIL && isBasicItem && (
          <ButtonGroup direction='horizontal'>
            <ButtonV2
              onClick={() => onSetMode(TransactionItemDrawerModeEnum.EDIT)}
              isSecondary
              isDisabled={isLoading}
            >
              {t('edit')}
            </ButtonV2>
          </ButtonGroup>
        )}
      </div>
    );
  }
);
TransactionItemHeader.displayName = 'TransactionItemHeader';
